import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { filter, map, Observable, switchMap } from 'rxjs';

import { AUTHENTICATION_CONFIG } from '../injection-tokens/config.token';
import { AuthenticationConfig } from '../models/authentication-config.model';
import { AuthenticationService } from '../service/authentication.service';

export const isAuthenticatedGuard: () => Observable<boolean | UrlTree> = () => {
  const router = inject(Router);
  const config: AuthenticationConfig = inject(AUTHENTICATION_CONFIG);
  const service: AuthenticationService = inject(AuthenticationService);
  return service.pendingRedirect$.pipe(
    filter((pending) => !pending),
    switchMap(() => service.user$),
    map((user) => {
      if (!user) {
        return config.createUrlTree ? config.createUrlTree(router) : false;
      }

      if (!user.primaryEmail) {
        service.signOut();
        return config.createUrlTree ? config.createUrlTree(router) : false;
      }
      return true;
    })
  );
};
